@if (header || (!pagination && showReset)) {
  <div class="d-flex gap-3 align-items-center justify-content-between">
    <h2 class="header-top">
      @if (header) {
        {{ header }}
      } @else {
        &nbsp;
      }
    </h2>
    @if (!pagination) {
      <ng-template [ngTemplateOutlet]="reset"></ng-template>
    }
  </div>
}

<ag-grid-angular
  class="ag-grid ag-theme-balham {{ gridCssClass }}"
  [components]="components"
  [rowData]="initialRowData"
  [gridOptions]="gridOptions"
  [suppressScrollOnNewData]="suppressScrollOnNewData"
  (cellClicked)="onCellClicked($event)"
  (cellValueChanged)="cellValueChanged($event)"
  (columnMoved)="saveState()"
  (columnPinned)="saveState()"
  (columnResized)="saveState()"
  (columnVisible)="saveState()"
  (filterChanged)="filterChanged()"
  (gridReady)="gridReady($event)"
  (rowDataUpdated)="rowDataUpdated()"
  (rowDragMove)="onRowDragMove($event)"
  (rowSelected)="onRowSelected($event)"
  (sortChanged)="saveState()"
>
</ag-grid-angular>

@if (pagination) {
  <ng-template [ngTemplateOutlet]="reset"></ng-template>
}

<ng-template #reset>
  @if (showReset) {
    <div class="d-flex gap-1 reset-buttons" [class.reset-pagination]="pagination">
      <button type="button" class="btn btn-primary" (click)="resetColumns()">
        <div class="d-flex align-items-center gap-1">
          <i class="fa fa-undo"></i>
          <span i18n>Columns</span>
        </div>
      </button>
      <button type="button" class="btn btn-primary" (click)="resetFilters()">
        <div class="d-flex align-items-center gap-1">
          <i class="fa fa-undo"></i>
          <span i18n>Filters</span>
        </div>
      </button>
    </div>
  }
</ng-template>
